// extracted by mini-css-extract-plugin
export var bigPersons = "ManagementCard-module--bigPersons--704a6";
export var card = "ManagementCard-module--card--dfc49";
export var fadeInAnimation = "ManagementCard-module--fadeInAnimation--7361b";
export var image = "ManagementCard-module--image--6a50f";
export var leadership = "ManagementCard-module--leadership--b6221";
export var linkedinIcon = "ManagementCard-module--linkedinIcon--d08f6";
export var linkedinLink = "ManagementCard-module--linkedinLink--cf990";
export var linkedinName = "ManagementCard-module--linkedinName--44341";
export var name = "ManagementCard-module--name--19f11";
export var personData = "ManagementCard-module--personData--d1c91";
export var picture = "ManagementCard-module--picture--762e4";
export var pictureWrapper = "ManagementCard-module--pictureWrapper--8c788";
export var position = "ManagementCard-module--position--1b692";